import { IHeader } from '@/bundles/BaseTable/interfaces';
import { withHeaderTitles } from '@/bundles/BaseTable/helpers/withHeaderTitles';

// TasksTable never takes Vuetify's default header path: it renders its own header row in the
// `#headers` slot and reads `column.title` off the slot payload. Vuetify still builds those
// columns from this data and has no `text` -> `title` fallback, so the labels come from `title`.
const defaultHeaders: IHeader[] = withHeaderTitles([
  { text: 'Title', align: 'left', value: 'title' },
  { text: 'Due Date', value: 'date_due' },
  { text: 'Priority', value: 'priority' },
  { text: 'Date Created', value: 'date_created' },
  { text: 'Assigned By', value: 'assigned_by.name' },
  { text: 'Assigned To', value: 'assigned_to.name' },
  { text: 'Type', value: 'type' },
  { text: 'Status', value: 'status' },
  { text: 'Related To', value: '' },
]);

export const getTasksTableHeaders = (): IHeader[] => {
  return defaultHeaders;
}
